module.exports = [{
      plugin: require('../../../plugins/gatsby-powergo-brp-smartsite-theme/gatsby-browser.js'),
      options: {"plugins":[],"instockToken":"1a640b99f1e05dab342fd44fc53e528673056fe5","sourceEnv":"production","websiteDomain":"www.adrenalinequebec.ca"},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
